import axios from 'axios';
import { TOKEN_KEY } from './authStore';

const createInstance = () => {
    const instance = axios.create({
        baseURL: import.meta.env.VITE_API_HOST,
        headers: {
            'Cache-Control': 'no-cache',
            Pragma: 'no-cache',
            Expires: '0',
        },
    });

	instance.interceptors.request.use(
        async (config) => {
            const token = localStorage.getItem(TOKEN_KEY);
            if (config.headers) {
                // @ts-ignore
                config.headers.common['Authorization'] = `Bearer ${token}`;
            }

            return config;
		},
		(error) =>  {
			return Promise.reject(error);
		},
	);

	instance.interceptors.response.use(
        (response) => {
			return response;
		},
		(error) => {
			return Promise.reject(error);
		},
    );

	return instance;
};

const axiosInstance = createInstance();
export default axiosInstance;